<template>
    <div class="container clearfix">
        <div class="registration-form">
            <fieldset>
                <legend>新規登録</legend>
                <hr>
                <div class="form-column">
                    <input name="username" class="form-control" placeholder="ユーザー名" id="username" maxlength="255" v-model="profile.username">
                </div>
                <div class="form-column">
                    <input name="email" class="form-control" placeholder="Email" id="email" maxlength="255" v-model="profile.email">
                </div>
                <div class="form-column">
                    <input name="password" type="password" class="form-control" placeholder="パスワード" id="password" maxlength="255" v-model="profile.password">
                </div>
                <div class="form-column">
                    <input name="password_confirmation" type="password" class="form-control" placeholder="パスワード(確認)" maxlength="255" id="password_confirmation" v-model="profile.password_confirmation">
                </div>
                <div class="form-column">
                    <input name="last_name" class="form-control" placeholder="姓" id="last_name" maxlength="50" v-model="profile.last_name">
                </div>
                <div class="form-column">
                    <input name="first_name" class="form-control" placeholder="名" id="first_name" maxlength="50" v-model="profile.first_name">
                </div>
            </fieldset>
            <div class="registration-btn">
                <button class="btn btn-primary" @click="register">登録</button>    
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { Message } from 'element-ui'
import $userRepository from '../../backend/userRepository'

export default {
    data() {
        return {
            profile: {
                username: '',
                email: '',
                password: '',
                password_confirmation: '',
                last_name: '',
                first_name: ''
            },
            errorMessage: '',
            validate_flag: false,
            response: null
        }
    },
    computed: {
        ...mapState({
            errorMessage: state => (state.auth.errorMessage)
        })
    },
    mounted() {
        this.$store.commit('auth/setErrorMessage', null)
    },
    methods: {
        // ユーザ登録
        async register() {
            this.validate();
            if(this.validate_flag) {
                this.validate_flag = false;
                return;
            }
            
            this.errorMessage = '';
            
            this.response = await $userRepository.register(this.profile);
            if(this.response.status === 201) {
                Message({  // 画面遷移中に消えないように、他のMessageコンポーネントとは少し設定を変えています
                    message: 'ユーザ仮登録しました。ご登録のアドレスに送られたメールから本登録してください',
                    type: 'success',
                    duration: 0,
                    showClose: true
                });
                this.$router.push({ path: '/'});
            }
            if(this.response.status === 400) {
                Message({
                    message: '既に登録済のメールアドレスです',
                    type: 'error'
                });
            }
            // その他のバックエンドで検知したエラーはerrorMessageコンポーネントで表示する
        },
        // formではなくdataを利用してバックエンドに送信するため、フロントで検知したエラーはinput属性ではなく下記でバリデーションチェックを行う
        validate() {
            if (!this.profile.username
                || !this.profile.email
                || !this.profile.password
                || !this.profile.password_confirmation
                || !this.profile.last_name
                || !this.profile.first_name) {
                Message({
                    message: '未入力の項目があります',
                    type: 'error'
                });
                this.validate_flag = true;
                return;
            }
            if (!this.profile.email.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.+-]{1,}\.[A-Za-z0-9]{1,}$/)) {
                Message({
                    message: 'メールアドレスの形式が不正です',
                    type: 'error'
                });
                this.validate_flag = true;
                return;
            }
            if (this.profile.password != this.profile.password_confirmation) {
                Message({
                    message: 'パスワードと確認用パスワードが一致しません',
                    type: 'error'
                });
                this.validate_flag = true;
            }
        }
    }
}
</script>

 <style scoped>
 .registration-form {
     position: absolute;
     top: 50%;
     left: 50%;
     transform: translate(-50%, -50%);
     width: 80%;
     max-width: 400px;
 }
 .form-column {
     margin-bottom: 10px;
 }
 .registration-btn {
     text-align: center;
     margin: 10px;
 }

 </style>